import {
  defineTargetTableConfig,
  TargetTable,
  TargetTableProps,
} from 'components/DataExpansionComponents/Common/TargetTable/TargetTable'
import ConvenienceDoorExportModal from 'components/Modals/ExportModal/ConvenienceDoorExportModal'
import {
  getConvenienceDoorList,
  getConvenienceDoorSummary,
} from 'services/places'
import {
  GOOGLE_PLACE_DOORS_DEFAULT_COLUMN_VISIBILITY,
  GOOGLE_PLACE_DOORS_INITIAL_COLUMN_ORDER,
  GOOGLE_PLACE_DOORS_PROXY_ACCESSORS,
  GOOGLE_PLACE_DOORS_SORTABLE_FIELDS,
} from '../../GooglePlaceBase/googlePlaceDoorsTargetTable'
import { ConvenienceDoorsFilterset } from './ConvenienceDoorsFilterset'
import { useConvenienceDoorsTableCols } from './ConvenienceDoorsTableColumns'

export const convenienceDoorsTableConfig = defineTargetTableConfig({
  // Convenience door columns nest under `cstore` (GooglePlaceBaseDoorTableColumns
  // accesor="cstore", detail link `/convenience/door/<cstore.id>`). App vertical
  // `convenience` maps to unified `cstore`.
  vertical: 'convenience',
  rowConfig: { accessor: 'cstore' },
  filterIdentifier: 'CONVENIENCE_DOOR_TABLE',
  savedPresetsIdentifier: 'CONVENIENCE_DOOR_TABLE',
  companyTypeSlug: 'convenience',
  tableTypeSlug: 'convenience-doors',
  sortableFields: GOOGLE_PLACE_DOORS_SORTABLE_FIELDS,
  preferredGroupOrder: ['Target Attributes', 'Campaigns and Deals'],
  searchPlaceholder: 'Search convenience stores by name',
  ...GOOGLE_PLACE_DOORS_PROXY_ACCESSORS,
  initialColumnOrder: GOOGLE_PLACE_DOORS_INITIAL_COLUMN_ORDER,
  defaultColumnVisibility: GOOGLE_PLACE_DOORS_DEFAULT_COLUMN_VISIBILITY,
  useColumns: useConvenienceDoorsTableCols,
  Filterset: ConvenienceDoorsFilterset,
  ExportModal: ConvenienceDoorExportModal,
  // dev moved the convenience-door fetchers off the `api` service hook
  // (`api.getConvenienceDoorList`) to standalone exports in `services/places`.
  resolveLegacyActions: () => ({
    listAction: getConvenienceDoorList,
    summaryAction: getConvenienceDoorSummary,
  }),
})

export function ConvenienceDoorTable(
  props: Omit<TargetTableProps, 'AfterSearchComponent'>
) {
  return <TargetTable config={convenienceDoorsTableConfig} {...props} />
}
